import drProcess from './dr-process-item.vue'
import drProcessAutocomplete from './dr-process-autocomplete.vue'

const schema = {
  allowInToolbox: true,
  $Type: 'dr-process-item',
  name: 'ForceBPM process',
  group: 'Advanced',
  icon: 'project-diagram',
  properties: {
    $ID: {
      name: 'vuetifyWidgets.dr-base.id',
      type: 'string'
    },
    Class: {
      name: 'vuetifyWidgets.dr-base.cssClass',
      type: 'string'
    },
    Process: {
      name: 'vuetifyWidgets.dr-process.process',
      type: 'any',
      component: drProcessAutocomplete
    },
    StartProcessButton: {
      name: 'vuetifyWidgets.dr-process.startProcessButton',
      type: 'string',
      default: 'Start process'
    },
    Disabled: {
      name: 'vuetifyWidgets.dr-process.disabled',
      hint: 'vuetifyWidgets.dr-process.hint',
      type: 'string',
      default: ''
    },
    WithoutSubmitButton: {
      name: 'vuetifyWidgets.dr-process.withoutSubmitButton',
      type: 'boolean',
      default: false
    },
    OnProcessStarted: {
      name: 'vuetifyWidgets.dr-process.onProcessStarted',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'dataSourceAction',
        text: 'Data Source Action'
      }]
    },
    FormioParams: {
      name: 'vuetifyWidgets.dr-process.formioParams',
      type: 'any',
      component: 'dr-object-editor'
    }
  }
}

export default {
  schema,
  component: drProcess
}
